import * as React from 'react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Command } from 'lucide-react';

import styled from 'styled-components';

import { MenuItems } from 'types';
import { ExitButton, UserInfo } from 'atoms';
import { MenuItemList, LanguageSwitcher } from 'molecules';

import { Colors } from 'services/ColorService';

export interface IMenuComponent {
  activeMenu?: MenuItems;
  menuItems: ReactNode[];
  onExit: () => void;
  /** Opens the command palette — a pointer entry point for touch / no-keyboard. */
  onOpenPalette: () => void;
  /**
   * Колокольчик уведомлений (ТЗ 0068) — СЛОТОМ, а не встроенным контейнером.
   *
   * Этот компонент презентационный и имеет сториз; контейнер, тянущий данные
   * через Apollo, сломал бы их. Тот же приём уже применён к `menuItems`.
   */
  notifications?: ReactNode;
  userFirstName?: string | null;
  userLastName?: string | null;
  userEmail?: string | null;
}

export const MenuComponent = ({
  menuItems,
  onExit,
  onOpenPalette,
  notifications,
  userFirstName,
  userLastName,
  userEmail,
}: IMenuComponent) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <MenuItemList>{menuItems}</MenuItemList>
        <RightGroup>
          {notifications}
          <PaletteTrigger
            type="button"
            onClick={onOpenPalette}
            title={t('commandPalette.help.openTrigger')}
            aria-label={t('commandPalette.help.openTrigger')}
          >
            <Command size={20} strokeWidth={2} />
          </PaletteTrigger>
          <LanguageSwitcher />
          <UserInfo
            firstName={userFirstName}
            lastName={userLastName}
            email={userEmail}
          />
          <ExitButton onClick={onExit} />
        </RightGroup>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: ${Colors.White};
  padding: 21px 2px;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: inherit;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const PaletteTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid ${Colors.SecondLightGray};
  border-radius: 8px;
  cursor: pointer;
  color: ${Colors.Gray};
  background: ${Colors.White};
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: ${Colors.Blue};
    border-color: ${Colors.Blue};
  }
`;
